export default "__VITE_ASSET__DwD6Ttd$__"